var map = {
	"./asmf.jpg": 420,
	"./bnbdf.jpg": 8928,
	"./bnf.jpg": 2373,
	"./brac.png": 3642,
	"./brac_small.png": 2074,
	"./buro-bangladesh.png": 5650,
	"./complete.gif": 4910,
	"./crisil_logo.png": 5256,
	"./demo.png": 8233,
	"./ecodev_logo.png": 9864,
	"./employees.png": 7209,
	"./enf.jpg": 2683,
	"./farmers.png": 2678,
	"./fnf.jpg": 6601,
	"./frf.jpg": 6243,
	"./gi1.gif": 9623,
	"./gi2.gif": 7513,
	"./gi3.gif": 5427,
	"./gi4.gif": 1999,
	"./hif.jpg": 1767,
	"./inf.jpg": 5532,
	"./mpoweru_logo.png": 9537,
	"./msi.png": 7282,
	"./msme.png": 3751,
	"./no_internet.gif": 4605,
	"./psf.png": 4115,
	"./rdrs-logo.png": 7225,
	"./rdrs_small.png": 6771,
	"./severconnect.gif": 8709,
	"./student.png": 2458,
	"./swf.jpg": 5257,
	"./tef.jpg": 2857,
	"./tos1.gif": 2147,
	"./tos2.gif": 9076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;